import React from 'react';
import Inc from './include.js';
import './demi.scss';

class Demi extends React.Component {
	//最初の挨拶、戻ってきた時、要修正、ＧＯ、失敗
	constructor(props){
		super(props);
		this.state = {
			selected: [false,false,false,false],
		};
	}

	select (index){
		if( this.props.step!==1 ){
			return;
		}
		let selected = this.state.selected;
		selected[index] = !selected[index];
		
		this.props.setSelected(selected);
		this.setState({selected:selected});
	}

	render (){
		if( !this.props.data || !this.props.data.cover_ids ){
			return (null);
		}
		let selected = this.state.selected;
		if( this.props.reason ){
			for( let i=0 ; i<selected.length ; i++ ){
				if( this.props.reason[i]==="1" ){
					selected[i] = true;
				}
			}
		}

		const params = this.props.data.cover_ids.map( (value,index)=>{
			const key = "param"+index;
			let classname = "box box"+index;
			if( this.props.step!==1 ){
				classname += " disabled";
			}
			let banclass = "fas fa-ban";
			if( this.props.step===5 ){
				banclass = "fas fa-skull-crossbones";
			}
			let prev= null;
			if( this.props.data.original_ids[index]!==value ){
				prev = Inc.TYPE_NAMES[index][this.props.data.original_ids[index]];
			}
			return (
				<button
					onClick={()=>this.select(index)}
					className={classname} key={key}
					>
					<div className="inner">
						<div className="name">
							{Inc.PARAM_NAMES[index]}
						</div>
						<div className="value">
							{Inc.TYPE_NAMES[index][value]}
						</div>
						{prev &&
						<div className="prev">{prev}</div>
						}
						{selected[index] &&
						<div className="selected">
							<i className={banclass}></i>
						</div>
						}
					</div>
				</button>
			)
		});
		let voice = 0;
		if( this.props.data.appear>1 ){
			voice = 1;
		} else if( this.props.step===2 ){
			voice = 2;
		} else if( this.props.step===3 ){
			voice = 3;
		} else if( this.props.step===5 ){
			voice = 4;
		}

		const figureclass = "fas fa-"+Inc.FIGURES[this.props.data.cover_ids[0]];
		return (
			<div id="demi">
				<div className="demi_name">
					<i className="fas fa-user"></i> {this.props.data.name}
				</div>
				<div className="figure">
					<i className={figureclass}></i>
				</div>
				<div className="prompt">
					<p>{this.getPrompt(this.props.data,voice)}</p>
				</div>
				{params}
			</div>
		)
	}
	getPrompt (demi,num){
		let text = Inc.PROMPTS[ demi.voice_id ][ num ];
		return text.replace("[NAME]",demi.name);
	}
}

export default Demi;